function buildEntityMetaDefinition(/* contentType */) {}

export default () => ({
  buildEntityMetaDefinition,
});
